module.exports = __webpack_public_path__ + "static/media/Cats eyes 04_SPANSKA-mixdown.a4c07685.mp3";